module.exports = __webpack_public_path__ + "img/shopify-home-page-template-pagefly-fabulous-001.307d7c3e.png";